import { DocumentType } from 'shared/domains/apollo/generated/types';
import { DuplicateComposedDialog } from './DuplicateComposedDialog';
import { DuplicateFreeTextDialog } from './DuplicateFreeTextDialog';
import { NotSupportedDialog } from './NotSupportedDialog';
import { useDocumentData } from './useDocumentData';
export function DuplicateDocumentDialog(props) {
    const { id, onDuplicated, onClose } = props;
    const { documentName, documentType } = useDocumentData(id);
    if (documentType === DocumentType.Uploaded) {
        return <NotSupportedDialog documentName={documentName} onClose={onClose}/>;
    }
    if (documentType === DocumentType.Freetext) {
        return <DuplicateFreeTextDialog documentId={id} documentName={documentName} onClose={onClose}/>;
    }
    return (<DuplicateComposedDialog documentId={id} documentName={documentName} onClose={onClose} onDuplicated={onDuplicated}/>);
}
